import {createRecipeContext} from '@chakra-ui/react3'
import chipRecipe from './index.recipe'

const {withContext} = createRecipeContext({
    recipe: chipRecipe
})

const Chip = withContext('button')

export default Chip
